import {APIENDPOINT} from '../constants';

var APIURL = window.bookingsUrl + APIENDPOINT;


export default {
    init() {

	    // console.log("sdsdsd");
        $("a").click(function (event) {
            var link = this.href;
            if (link.indexOf("#open-login") > 0) {
                var $signin = $('.sign-in-page');
                var $loginOverlay = $('.login-overlay');
                $signin.removeClass('hidden');
                $loginOverlay.removeClass('hidden');
                setTimeout(function () {
                    $signin.removeClass('-right');
                }, 200);
                return false;
            }

        });





        $('.toggle').on('click', function () {
            $('.menu').toggleClass('hidden');
        });
        $('.login-form').on('submit', function (e) {
            var username = $('.username-login').val();
            var pass = $('.password-login').val();
            e.preventDefault();
            $('.login-error-text').text('');
            var errorText = 'Wrong username or password';
            var userAuth = 'Basic ' + btoa(username + ':' + pass);
            $.ajax({
                url: window.my_ajax_object.ajax_url,
                dataType: "json",
                method: 'POST',
                data: {
                    action: 'login',
                    mail: username,
                    pass: pass,
                }, success: function (response) {
	                console.log(userAuth);
                    if (response.status < 400) {
                        $.ajax({
                            url: APIURL + 'users/me',
                            method: 'GET',
                            beforeSend: function (req) {
                                req.setRequestHeader('Authorization', userAuth);
                            },
                            success: function (user) {
                                location.reload();
                            }, error: function (error) {
                                $.ajax({
                                    method: 'POST',
                                    url: window.my_ajax_object.ajax_url,
                                    dataType: "json",
                                    data: {
                                        action: 'logout',
                                    }
                                });
                                console.log(error);
                                $('.login-error-text').text(errorText);
                            }
                        });
                    }
                }, error: function (error) {
                    console.log(error);
                    if (error.status === 404) {
                        //Check if user exist in API
                        $.ajax({
                            url: APIURL + 'users/me',
                            method: 'GET',
                            beforeSend: function (req) {
                                req.setRequestHeader('Authorization', userAuth);
                            },
                            success: function (user) {
                                $.ajax({
                                    method: 'POST',
                                    url: window.my_ajax_object.ajax_url,
                                    dataType: "json",
                                    data: {
                                        action: 'epicenter_create_user',
                                        mail: user.mail,
                                        username: username,
                                        password: pass,
                                        firstname: user.firstname,
                                        lastname: user.lastname,
                                        company: user._embedded.company.title,
                                        location: user._embedded.company.location,
                                    }, success: function (success) {
                                        location.reload();
                                    }, error: function (error) {
                                        console.log("Error", error);
                                    }
                                });
                            }, error: function (error) {
                                $('.login-error-text').text(errorText);
                            }
                        });
                    } else {
                        $.ajax({
                            url: APIURL + 'users/me',
                            method: 'GET',
                            beforeSend: function (req) {
                                req.setRequestHeader('Authorization', userAuth);
                            },
                            success: function (user) {
                                $.ajax({
                                    method: 'POST',
                                    url: window.my_ajax_object.ajax_url,
                                    dataType: "json",
                                    data: {
                                        action: 'epicenter_login_api',
                                        username: username,
                                        password: pass,
                                    }, success: function (success) {
                                         location.reload();
                                    }, error: function (error) {
                                        $('.login-error-text').text(errorText);
                                        console.log("Error", error);
                                    }
                                });
                            }, error: function (error) {
                                $('.login-error-text').text(errorText);
                            }
                        });
                    }
                }
            });
        });
        $('.forgot-password-form').on('submit', function (e) {
            e.preventDefault();
            var mail = $('.email-forgot').val();
            $.ajax({
                method: 'POST',
                url: window.my_ajax_object.ajax_url,
                dataType: "json",
                data: {
                    action: 'forgot_password',
                    mail: mail,
                }, success: function (response) {
                    $('.forgot-password-success-text').text(response.data);
                }, error: function (error) {
                    $('.forgot-password-error-text').text(error.responseJSON.data);
                }
            });
        });
        $('.example-event').on('click', function () {
            $(this).toggleClass('active');
        });
        $('.close-menu-icon').on('click', function (event) {
            var $menu = $('.menu-page');

            event.preventDefault();
            $menu.addClass('-left-50');
            $('.menu-overlay').fadeOut();
            setTimeout(function () {
                $menu.addClass('hidden');
            }, 500);
        });
        $('.open-menu-icon').on('click', function (event) {
            var $menu = $('.menu-page');
            $('.menu-overlay').fadeIn();

            event.preventDefault();
            $menu.removeClass('hidden');
            setTimeout(function () {
                $menu.removeClass('-left-50');
            }, 0);
        });

        var closeForm = function (event) {
            var $signin = $('.sign-in-page');
            var $pipedrive = $('.pipedrive-menu');
            var $desktop = $('.desktop-menu');

            $('#pipedrive-form').attr("src","");

            event.preventDefault();
            $signin.addClass('-right');
            $pipedrive.addClass('-right');
            var $loginOverlay = $('.login-overlay');
            var $pipedriveOverlay = $('.pipedrive-overlay');
            $desktop.removeClass('max-h-0');
            setTimeout(function () {
                $desktop.removeClass('closed');
                $signin.addClass('hidden');
                $pipedrive.addClass('hidden');
                $loginOverlay.addClass('hidden');
                $pipedriveOverlay.addClass('hidden');
            }, 500);
        }

        $('.sign-in-cross').on('click', closeForm);

        $('.sign-in-link').on('click', function (event) {
            var $loginOverlay = $('.login-overlay');
            $loginOverlay.removeClass('hidden');
            var $signin = $('.sign-in-page');
            var $menu = $('.menu-page');
            var $desktop = $('.desktop-menu');
            event.preventDefault();

            if (!$($signin).hasClass('hidden')) {
                closeForm(event);
                return;
            }

            $desktop.addClass('max-h-0');
            $menu.addClass('-left-50');
            setTimeout(function () {
                $desktop.addClass('closed');
                $menu.addClass('hidden');
            }, 500);
            $signin.removeClass('hidden');
            setTimeout(function () {
                $signin.removeClass('-right');
            }, 0);

        });

        $('.pipedrive-link').on('click', function (event) {
            var $loginOverlay = $('.pipedrive-overlay');
            var $menu = $('.menu-page');
            $('#pipedrive-form').attr("src",this.getAttribute('data-pipedrive-url'));

            $loginOverlay.removeClass('hidden');
            var $pipedrive = $('.pipedrive-menu');

            var $desktop = $('.desktop-menu');
            event.preventDefault();

            if (!$($pipedrive).hasClass('hidden')) {
                closeForm(event);
                return;
            }
            $pipedrive.removeClass('-right');
            $desktop.addClass('max-h-0');

            setTimeout(function () {
                $desktop.addClass('closed');
                $menu.addClass('hidden');
            }, 500);
            $pipedrive.removeClass('hidden');
          setTimeout(function () {
              $pipedrive.removeClass('-right');
          }, 10);


        });


        $('.forgot-password-link').on('click', function (event) {
            var $this = $(this);

            event.preventDefault();
            $this.closest('.tab').addClass('hidden');
            $('.' + $this.data('target')).removeClass('hidden');
        });
        $('.toggle-password').on('click', function () {
            var $input = $(this).siblings('input')[0];
            if ($input.type === 'password') {
                $input.type = 'text';
            } else {
                $input.type = 'password';
            }
        });

        $('.password-input').keypress(function (e) {
            var s = String.fromCharCode(e.which);
            if (s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey) {
                $('.caps-warning').addClass('flex');
                $('.caps-warning').removeClass('hidden');
            } else {
                $('.caps-warning').addClass('hidden');
                $('.caps-warning').removeClass('flex');
            }
        });
        $('.password-input').keypress(function (e) {
            var s = String.fromCharCode(e.which);
            if (s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey) {
                $('.caps-warning').addClass('flex');
                $('.caps-warning').removeClass('hidden');
            } else {
                $('.caps-warning').addClass('hidden');
                $('.caps-warning').removeClass('flex');
            }
        });


        $('.member-square').on('click', function () {
            var $this = $(this);
            if ($this.hasClass('active')) {
                $this.removeClass('active');
                $('.member-quote').fadeOut('fast');
            } else {
                $('.member-square.active').each(function (index, value) {
                    $(value).removeClass('active');
                });
                var memberTitle = $this.data('member-title');
                var name = $this.data('title');
                var memberName = $this.data('member-name');
                var content = $this.data('content');
                $this.addClass('active');
                $('.member-quote').fadeOut('fast', function () {
                    $('.member-content').text(content);
                    $('.member-title').text('"' + name + '"');
                    $('.member-position').text(memberTitle);
                    $('.member-name').text(memberName);
                    $('.member-quote').fadeIn('fast');
                });
            }
        });

        $('.member-square').first().trigger('click');


        $('.member-skill-slider').on('click', function () {
            var $parent = $(this).parent('label');
            if ($parent.hasClass('active')) {
                $parent.removeClass('active');
            } else {
                $parent.addClass('active');
            }
        });
        $('.edit-profile-skills').change(function () {
            var $this = $(this);
            $.ajax({
                method: 'POST',
                url: window.my_ajax_object.ajax_url,
                dataType: "json",
                data: {
                    action: 'update_user_skill',
                    skill: $this.data('skill'),
                    active: $this.is(':checked') ? 1 : 0,
                }, success: function () {

                }, error: function (error) {
                    console.log("error", error);
                }
            });
        });
        $('.edit-profile-form').on('submit', function (e) {
            e.preventDefault();

            var results = {};
            $.each($(this).serializeArray(), function (i, field) {
                results[field.name] = field.value;

            });
            $.ajax({
                method: 'POST',
                url: window.my_ajax_object.ajax_url,
                dataType: "json",
                data: {
                    action: 'update_user',
                    facebook: results.contact_facebook,
                    instagram: results.contact_instagram,
                    linkedin: results.contact_linkedin,
                    twitter: results.contact_twitter,
                    mail: results.contact_mail,
                    phone: results.contact_phone,
                    description: results.description,
                    first_name: results.first_name,
                    last_name: results.last_name,
                    work_title: results.title,
                    receive_sms: results.sms == 'on',
                    incognito: results.incognito == 'on'
                }, success: function () {
                    location.reload();
                }, error: function (error) {
                    console.log("error", error);
                }
            });
        });

        $('.upload-icon').on('click', function () {
            $('.upload-image').trigger('click');
        });
        $('.upload-image').on('change', function () {
            var file = $(this).prop('files')[0];
            var formData = new FormData();
            formData.append('file', file);
            formData.append('action', 'upload_profile_pic');
            $.ajax({
                url: window.my_ajax_object.ajax_url,
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (data) {
                    var result = JSON.parse(data);
                    $('.profile-picture-top').attr('style', 'background: url(\'' + result.data.replace('\\', '') + '\') center center no-repeat; background-size: cover;');
                },
                error: function (error) {
                    console.log(error);
                }
            });
        });
        $('.edit-profile-icon').on('click', function () {
            $('.edit-profile-info').fadeIn();
            $('body').addClass('overflow-hidden');
        });
        $('.close-profile-modal').on('click', function () {
            $('body').removeClass('overflow-hidden');
            $('.edit-profile-info').fadeOut();
        });
		$('.close-cookie-modal').on('click', function () {
            $('body').removeClass('overflow-hidden');
            $('.cookie-concent').fadeOut();
        });
        function checkScroll() {
            var $header = $('.menu');
            if ($(window).scrollTop() > 10) {
                if ($header.hasClass('scrolltop')) {
                    $header.removeClass('scrolltop');
                }
            } else {
                if (!$header.hasClass('scrolltop')) {
                    $header.addClass('scrolltop');
                }
            }
        }


        $('.down-arrow').on('click', function () {
            var destination = $(this).closest('section').next('section');
            $('html, body').animate({
                scrollTop: (destination.offset().top - 100)
            }, 1000, 'swing');
        });

        $('.menu-parent').on('click', function () {
            var id = $(this).data('parent');
            $(this).toggleClass('active');
            $('[data-childof=' + id + ']').toggleClass('hidden flex');
        });
        
        $('.sign-out-link').on('click', function () {
            $.ajax({
                method: 'POST',
                url: window.my_ajax_object.ajax_url,
                data: {
                    action: 'logout',
                }, success: function () {
                    
                    location.href="/"+document.location.pathname.split("/")[1];
                }, error: function (error) {
                    console.log("error", error);
                }
            });
        });
        $('.news-next-page').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var nextPage = $this.data('page');
            $this.css('visibility', 'hidden');
            $.ajax({
                method: 'POST',
                url: window.my_ajax_object.ajax_url,
                dataType: "json",
                data: {
                    action: 'load_more_news',
                    nextpage: nextPage,
                }, success: function (response) {
                    if (response.status < 400) {
                        $('.news-container').append(response.data);
                        if (response.more_pages) {
                            $this.data('page', nextPage + 1);
                            $this.css('visibility', 'visible');
                        }
                    }
                }, error: function () {
                }
            });
        });
       
       var page = 2;
       $('.loadmore').on('click', function (e) {
           e.preventDefault();
           var $this = $(this);
           var nextPage = $this.data('page');
           
           $this.css('visibility', 'hidden');
           $.ajax({
               method: 'POST',
               url: window.my_ajax_object.ajax_url,
               dataType: "json",
               data: {
                   action: 'load_posts',
                   nextpage: page,
               }, success: function (response) {
                   if (response.status < 400) {
                       $('.blog-posts').append(response.data);
                       if (response.more_pages) {
                           page++;
                           $this.data('page', page);
                           $this.css('visibility', 'visible');
                       }
                   }
               }, error: function () {
               }
           });
       });
       
        
        

        // smooth scralling for #anchor links
        $("a.epi-menu-item").on("click", function(t) {
            var e = jQuery(this).attr("href");
            var re = /\#([^"]+)/;
            var element = e.match(re);
            if (element && element.length > 1 && document.getElementById(element[1])) {
              t.preventDefault();
              var i = jQuery(element[0]).offset().top;
              jQuery("body,html").animate(
                {
                  scrollTop: i,
                },
                1e3
              );
            }
        });

        checkScroll();
        $(window).on('scroll', checkScroll);
        $('.contact_phone').intlTelInput();
        $('.login-overlay').on('click', function(e){
            closeForm(e);
        });
        $('.login-overlay .sign-in-page').on('click', function(e){
            e.stopPropagation();
        })
    }

}
;
